export default "__VITE_ASSET__v4M0j3ix__"